import { redirect, Route } from '@tanstack/router'

import { rootRoute } from './root'

export const indexRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({
      to: '/casino/$category',
      params: { category: 'inicio' },
      search: true,
    })
  },
})
